module.exports = __webpack_public_path__ + "bdc040e69caea1be390da16f5eb26a3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/1.png
// module id = 314
// module chunks = 1